'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utilsLink = require('@bibliocommons/utils-link');

var _sharedJacketCover = require('@bibliocommons/shared-jacket-cover');

var _sharedJacketCover2 = _interopRequireDefault(_sharedJacketCover);

var _BibTextSlide = require('./BibTextSlide.component');

var _BibTextSlide2 = _interopRequireDefault(_BibTextSlide);

require('../styles/SliderJacketCover.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderJacketCover = function SliderJacketCover(_ref) {
  var handleClick = _ref.handleClick,
      item = _ref.item;
  return _react2.default.createElement(
    'div',
    { className: 'cp-slider-jacket-cover' },
    _react2.default.createElement(
      'a',
      { key: item.id, onClick: handleClick, href: '/item/show/' + (0, _utilsLink.metadataIdFixer)(item.id), target: '_parent' },
      _react2.default.createElement(_sharedJacketCover2.default, { renderDefault: function renderDefault() {
          return null;
        }, format: item.format, src: item.jacket.medium, alt: item.title }),
      _react2.default.createElement(_BibTextSlide2.default, { item: item })
    )
  );
};

SliderJacketCover.propTypes = {
  handleClick: _react2.default.PropTypes.func,
  item: _react2.default.PropTypes.shape({
    id: _react.PropTypes.string.isRequired,
    format: _react.PropTypes.string.required,
    jacket: _react.PropTypes.shape({
      medium: _react.PropTypes.string.isRequired
    }).isRequired,
    title: _react.PropTypes.string.required
  })
};

exports.default = SliderJacketCover;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/slider-jacket-cover/lib/components/SliderJacketCover.component.js
// module id = 587
// module chunks = 3 4 9